import React, {useState} from 'react';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import * as yup from 'yup';
import {Form, Formik} from 'formik';
import {useDispatch} from 'react-redux';
import api from '../services/api';
import {useHistory} from 'react-router-dom';

import Box from '@material-ui/core/Box';

import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';

import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import AppButton from '../components/AppButton';
import AppFormControl from '../components/AppFormControl';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import {addNotification, setAuthenticate, getCurrentUser} from '../redux/actions';

import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';

import OtpInput from 'react-otp-input';

import * as qs from 'query-string';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '67vh',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    backgroundImage: `url(${require('../assets/images/background.png')})`,
    backgroundSize: 'cover',
    objectFit: 'cover',
    backgroundRepeat: 'no-repeat',
  },
  card: {
    borderRadius: 25,
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    minHeight: '50vh',
  },
  cardRoot: {
    padding: 0,
  },
  cardContent: {
    minHeight: '50vh',
    '& > div': {
      overflow: 'visible!important',
    },
  },
  panel: {
    minHeight: '50vh',
  },
}));

const validationLoginSchema = yup.object().shape({
  email: yup.string().email('Debe ser un correo electrónico valido.').required('Correo electrónico es requerido.'),
  password: yup.string().required('Contraseña es requerida.'),
});

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

const CustomTab = withStyles((theme) => ({
  root: {
    minHeight: 60,
    border: 'none',
    backgroundColor: theme.palette.common.white,
    textTransform: 'uppercase',
  },
}))(Tab);

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const Login = ({location}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const [isPhone] = React.useState(true);
  const [hasOtpCode, setHasOtpCode] = React.useState(false);
  const [otpData, setOtpData] = React.useState({
    prefix: '',
    email: '',
    phone: '',
  });

  const login = async ({email, password}, {resetForm}) => {
    setLoading(true);
    try {
      await api.login(email, password);
      dispatch(getCurrentUser());
      dispatch(setAuthenticate(true));
      resetForm();
      let searchParse = qs.parse(location.search);
      if (searchParse.next) {
        history.push(searchParse.next);
      }
      history.push('/');
      dispatch(addNotification('Inicio de sesión con exito !', 'success'));
    } catch (e) {
      dispatch(addNotification('Error inesperado !', 'error'));
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const sendOTP = async () => {
    const {prefix, email, phone} = otpData;

    try {
      if (isPhone) {
        await api.authentication.create({
          strategy: 'sms',
          phone: phone,
          phone_country_code: prefix,
        });
      } else {
        await api.authentication.create({
          strategy: 'email',
          email: email,
        });
      }
      dispatch(addNotification('¡Código enviado!', 'success'));
      setHasOtpCode(true);
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    }
  };

  const handleChangeEmail = (event) => {
    setOtpData((prevState) => ({...prevState, email: event.target.value}));
  };

  const handleChangePhone = (phone, country) => {
    setOtpData((prevState) => ({
      ...prevState,
      phone,
      prefix: country.dialCode,
    }));
  };

  const _renderRegisterContent = () => {
    return (
      <React.Fragment>
        {isPhone ? (
          <PhoneInput
            country={'co'}
            enableSearch
            value={otpData.phone}
            onChange={handleChangePhone}
            inputStyle={{
              borderRadius: 10,
              width: '100%',
              borderColor: 'rgb(121,121,121)',
            }}
            buttonStyle={{
              borderBottomLeftRadius: 15,
              borderTopLeftRadius: 15,
              borderColor: 'rgb(121,121,121)',
            }}
            containerStyle={{
              width: '100%',
              marginTop: 29,
            }}
          />
        ) : (
          <AppFormControl type="email" name="email" onChange={handleChangeEmail} label="Correo electrónico" />
        )}

        {/*<Box mt={2} mb={3}>
          <Button color="primary" onClick={() => setIsPhone(!isPhone)}>
            o ingresar con tu {isPhone ? 'email' : 'celular'}
          </Button>
        </Box>*/}

        <Box mb={5}>
          <AppButton round onClick={sendOTP} disableElevation variant="contained" color="secondary">
            Enviar codigo
          </AppButton>
        </Box>

        {hasOtpCode && (
          <React.Fragment>
            <Box mb={3} clone>
              <Typography align="center">Te hemos enviado un código </Typography>
            </Box>

            <OtpInput
              containerStyle={{justifyContent: 'center'}}
              numInputs={4}
              inputStyle={{color: '#000', padding: 14, margin: '0 20px'}}
              separator={<span>-</span>}
            />

            <Box clone my={3}>
              <Divider />
            </Box>
            <Typography align="center">El código se reenviara automáticamente en: 20 </Typography>
          </React.Fragment>
        )}
        <Box mb={7} />
      </React.Fragment>
    );
  };

  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        <Grid container justify="center">
          <Grid xs={11} md={6}>
            <Card elevation={0} classes={{root: classes.cardRoot}} className={classes.card}>
              <CardContent className={classes.cardContent}>
                <AppBar elevation={0} position="static" color="default">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    <CustomTab label="Iniciar sesión" {...a11yProps(0)} />
                    <CustomTab label="Registrarse" {...a11yProps(1)} />
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                  index={value}
                  onChangeIndex={handleChangeIndex}
                >
                  <TabPanel className={classes.panel} value={value} index={0} dir={theme.direction}>
                    <Formik
                      initialValues={{
                        email: '',
                        password: '',
                      }}
                      validationSchema={validationLoginSchema}
                      onSubmit={login}
                      render={({handleChange, handleSubmit}) => (
                        <Form
                          onKeyPress={(event) => {
                            event.key === 'Enter' && handleSubmit();
                          }}
                        >
                          <Grid container>
                            <Grid item md={12}>
                              <AppFormControl
                                hasFormik
                                name="email"
                                handleChange={handleChange}
                                type="email"
                                label="Correo electrónico"
                              />
                            </Grid>
                            <Grid item md={12}>
                              <AppFormControl
                                hasFormik
                                name="password"
                                handleChange={handleChange}
                                type="password"
                                label="Contraseña"
                              />
                            </Grid>
                          </Grid>
                          <Box mt={3} display="flex" justifyContent="center">
                            <AppButton
                              round
                              disableElevation
                              variant="contained"
                              color="secondary"
                              type="submit"
                              onClick={handleSubmit}
                              disabled={loading}
                            >
                              Iniciar sesión
                            </AppButton>
                          </Box>
                        </Form>
                      )}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1} dir={theme.direction}>
                    {_renderRegisterContent()}
                  </TabPanel>
                </SwipeableViews>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Login;
